import { apiRequest } from '../lib/apiClient';

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

const titleize = (value = '') =>
  value
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getTrainingClasses = (token) =>
  apiRequest(
    '/training-sessions/classes',
    { headers: authHeaders(token) },
    'Failed to load training classes.'
  );

export const createTrainingClassMap = (trainingClasses = []) =>
  trainingClasses.reduce((acc, trainingClass) => {
    acc[trainingClass.name] = trainingClass;
    return acc;
  }, {});

export const getTrainingClassLabel = (trainingClassesByName, className) => {
  if (!className) return '-';
  return trainingClassesByName?.[className]?.displayName || className;
};

export const formatTrainingClassCategory = (category) => {
  if (!category) return '';
  return titleize(category);
};
